<template>
  <v-container style="background-color:white">
    <v-toolbar dark class="secondary">
      <v-toolbar-title>Create Lead From Customer</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="ml-4" dark flat icon @click="$emit('closeDialog')"><v-icon>cancel</v-icon></v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <!-- Contact Form -->
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container grid-list-md>
        <v-layout>
          <v-flex title indigo--text v-if="contact">
            Create Lead For: {{ customerSelect }}
          </v-flex>
          <v-toolbar dark color="primary">
            <v-toolbar-title><v-icon class="mr-2">person</v-icon>Customer:</v-toolbar-title>
            <v-autocomplete autofocus :loading="loading" :items="items" :search-input.sync="search" v-model="customerSelect" cache-items
              class="mx-3" flat hide-no-data hide-details label="Search Customers" solo-inverted @change="getContactDetails">
            </v-autocomplete>
          </v-toolbar>
        </v-layout>
        <p v-if="!customerSelect && validating === true" class="mt-3 title red--text">You Must Enter a Customer</p>
        <v-container grid-list-md>
          <v-layout justify-center>
            <span class="headline font-weight-thin">{{contact.type}} Information</span>
          </v-layout>
	        <v-layout row wrap>
            <v-flex xs12 v-if="contact.type == 'Builder'">
              <v-text-field v-model="builder.company_name" :rules="nameRules" :counter="30" label="Company Name (Builder Name)" required prepend-icon="home"></v-text-field>
            </v-flex>
            <!-- Create Builder Data -->
            <template v-if="contact.type != 'Builder'">
            <v-flex sm6 xs12>
              <v-text-field v-model="contactDetails.first_name" :rules="validationRequired" label="First Name" required prepend-icon="person"></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <v-text-field v-model="contactDetails.last_name" :rules="validationRequired" label="Last Name" required prepend-icon="person"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="contactDetails.email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
            </v-flex>
            <v-flex sm6 xs7>
              <v-text-field v-model="contactDetails.phone_1" :rules="validationRequired" name="phone1" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
            </v-flex>
            <v-flex sm5 xs4>
              <v-select v-model="contactDetails.phone_type_1" :items="phoneOptions" label="Type"></v-select>
            </v-flex>
            <v-flex sm1 xs1>
              <v-btn fab small color="primary" @click="phone2 = !phone2"><v-icon>{{ phone2 ? 'remove_circle' : 'add_circle' }}</v-icon></v-btn>
            </v-flex>
            <v-flex sm6 xs7 v-if="phone2">
              <v-text-field v-model="contactDetails.phone_2" name="phone2" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
            </v-flex>
            <v-flex sm5 xs4 v-if="phone2">
              <v-select v-model="contactDetails.phone_type_2" :items="phoneOptions" label="Type"></v-select>
            </v-flex>
            </template>
            <template v-if="contact.type == 'Builder'">
              <v-flex sm6 xs7>
                <v-text-field v-model="builder.phone_1" name="phone1" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
              </v-flex>
            </template>
            <!-- Secondary Contact Information -->
                <v-layout row wrap v-if="contact.type != 'Builder'">
                  <v-flex xs12 class="text-xs-right">
                    <v-chip color="indigo" text-color="white" @click="showSecondaryContact = !showSecondaryContact; lastName()"><v-icon class="pr-3 hover">person_add</v-icon>{{ showSecondaryContact ? 'Remove Additional Contact' : 'Add Additional Contact' }}</v-chip>
                    <!-- <v-btn small color="primary" @click="showSecondaryContact = !showSecondaryContact">{{ showSecondaryContact ? 'Remove Additional Contact' : 'Add Additional Contact' }}</v-btn> -->
                  </v-flex>
                  <template v-if="showSecondaryContact">
                  <v-flex sm6 xs12>
                    <v-text-field v-model="secondaryContact.secondaryContact_first_name" :rules="validationRequired" label="First Name" required prepend-icon="person"></v-text-field>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-text-field v-model="secondaryContact.secondaryContact_last_name" :rules="validationRequired" label="Last Name" required prepend-icon="person"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="secondaryContact.secondaryContact_email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
                  </v-flex>
                  <v-flex sm6 xs7>
                    <v-text-field v-model="secondaryContact.secondaryContact_phone_1" name="secondaryContact_phone1" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                  </v-flex>
                  <v-flex sm5 xs4>
                    <v-select v-model="secondaryContact.secondaryContact_phone_type_1" :items="phoneOptions" label="Type"></v-select>
                  </v-flex>
                  <v-flex sm1 xs1>
                    <v-btn fab small color="primary" @click="secondaryPhone2 = !secondaryPhone2"><v-icon>{{ secondaryPhone2 ? 'remove_circle' : 'add_circle' }}</v-icon></v-btn>
                  </v-flex>
                  <v-flex sm6 xs7 v-if="secondaryPhone2">
                    <v-text-field v-model="secondaryContact.secondaryContact_phone_2" name="secondaryContact_phone2" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
                  </v-flex>
                  <v-flex sm5 xs4 v-if="secondaryPhone2">
                    <v-select v-model="secondaryContact.secondaryContact_phone_type_2" :items="phoneOptions" label="Type"></v-select>
                  </v-flex>
                  </template>
                </v-layout>
            <!-- Address Information -->
            <v-divider style="background-color: rgb(63, 81, 181); margin-top:20px; margin-bottom:20px; border: solid 1px rgb(63, 81, 181)" light v-if="showSecondaryContact"></v-divider>
            <v-layout row wrap>
            <v-flex xs12>
              <v-text-field v-model="contactAddress.address" :rules="contact.type == 'Builder' ? [] : validationRequired" name="address" label="Contact Address" prepend-icon="add_location"></v-text-field>
            </v-flex>
            <v-flex sm6 xs12>
              <v-text-field v-model="contactAddress.city" :rules="contact.type == 'Builder' ? [] : validationRequired" name="city" label="Contact City" prepend-icon=" "></v-text-field>
            </v-flex>
            <v-flex sm3 xs6>
              <v-text-field v-model="contactAddress.state" :rules="contact.type == 'Builder' ? [] : validationRequired" name="state" label="Contact State" prepend-icon=" "></v-text-field>
            </v-flex>
            <v-flex sm3 xs6>
              <v-text-field v-model="contactAddress.zip" :rules="contact.type == 'Builder' ? [] : validationRequired" name="zip" label="Contact Zip"></v-text-field>
            </v-flex>
            <template v-if="contact.type != 'Builder'">
              <v-flex sm6 xs12>
                <v-select v-model="opportunity.source" :rules="validationRequired" :items="sourceOptions" label="How did they hear about us?" prepend-icon="record_voice_over" required></v-select>
              </v-flex>
              <v-flex xs12 v-if="opportunity.source === 'Referral'">
                <v-text-field v-model="opportunity.referred_by" label="Who referred this contact?" prepend-icon="record_voice_over"></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="opportunity.source === 'Convention'">
                <v-text-field v-model="opportunity.referred_by" label="Convention Information" prepend-icon="record_voice_over"></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="opportunity.source === 'Other'">
                <v-text-field v-model="opportunity.referred_by" label="Give More Information" prepend-icon="record_voice_over"></v-text-field>
              </v-flex>
              <v-flex xs12 v-if="contact.type !== 'Builder'">
                <v-select v-model="salesRep" :rules="validationRequired" :items="userNames" label="Sales Rep:" prepend-icon="person_add" required></v-select>
              </v-flex>
            </template>
            </v-layout>
          </v-layout>
<!-- Lead Opportunity Data -->
          <template v-if="contact.type === 'Lead'">
            <v-layout mt-4 justify-center>
              <span class="headline font-weight-thin">Opportunity Details</span>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm6 xs12>
                <v-text-field v-model="opportunity.property_survey" label="Property Survey?"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="opportunity.other_designs" label="Other Designs?"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="opportunity.financing" label="Financing?"></v-text-field>
              </v-flex>
                <v-flex sm3 xs6>
                  <v-text-field v-model="opportunity.budget_min" label="Min Budget" value="0.00" prefix="$"></v-text-field>
                </v-flex>
                <v-flex sm3 xs6>
                  <v-text-field v-model="opportunity.budget_max" label="Max Budget" value="0.00" prefix="$"></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-if="type !== 'EditLead'">
              <v-flex xs12>
                <v-checkbox v-model="addressSameAsContact" label="Property Address Same As Customer" color="success" hide-details></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!addressSameAsContact || type === 'EditLead'">
              <v-flex xs12>
                <v-text-field v-model="opportunity.address" :rules="validationRequired" name="address" label="Property Address"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="opportunity.city" :rules="validationRequired" name="city" label="Property City"></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="opportunity.state" :rules="validationRequired" name="state" label="Property State (i.e. FL)"></v-text-field>
              </v-flex>
              <v-flex sm3 xs6>
                <v-text-field v-model="opportunity.zip" :rules="validationRequired" name="zip" label="Property Zip"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs9>
                <v-text-field v-model="opportunity.building_dept" name="building_dept" label="Building Department"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field v-model="opportunity.gate_code" name="gate_code" label="Gate Code"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select clearable v-model="opportunity.builder" @input="getBuilderContacts(opportunity.builder)" :items="builderDropDownList" label="Assign a Builder" required></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select clearable v-model="opportunity.builder_contact" v-if="opportunity.builder" :items="builderContactsDropDownList" :label="'Project Contact from ' + opportunity.builder" required></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="opportunity.hoa" label="HOA / Neighborhood"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="opportunity.description" multi-line rows="1" auto-grow label="Description of Work"></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="opportunity.projectNotes" multi-line rows="1" auto-grow label="General Project Notes"></v-textarea>
              </v-flex>
            </v-layout>
          </template>
<!-- Builder Contacts -->
          <template v-if="contact.type == 'Builder'">
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <p class="orange white--text">Add Builder Contacts. You can add as many as needed.</p>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builderContacts.first_name" :counter="30" label="First Name" required prepend-icon="person"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builderContacts.last_name" :counter="30" label="Last Name" required prepend-icon="person"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builderContacts.email" :rules="emailRules" label="Email" prepend-icon="email"></v-text-field>
              </v-flex>
              <v-flex sm6 xs12>
                <v-text-field v-model="builderContacts.phone" name="phone" label="Phone" mask="phone" prepend-icon="phone"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-chip color="indigo" text-color="white" @click="createBuilderContacts()"><v-icon class="pr-3 hover">person_add</v-icon>Add Another Builder Contact</v-chip>
              </v-flex>
            </v-layout>
            <p></p>
          </template>
          <!-- Added Builder Contacts List -->
          <v-layout row wrap>
          <v-chip v-if="builderContactsArray.length > 0" label color="pink" text-color="white">
            <v-icon left>label</v-icon>Builder Contacts Added:
          </v-chip>
          <template v-for="(contact, index) in builderContactsArray">
            <v-chip @input="removeBuilderContact(index)" v-model="contact.index" close :key="index" color="indigo" text-color="white">
              <v-avatar>
                <v-icon>account_circle</v-icon>
              </v-avatar>
              {{ contact.first_name }} {{ contact.last_name }}
            </v-chip>
          </template>
          </v-layout>
        </v-container>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { db, storage } from '../../firebaseInit'
import Uploader from '../../helpers/Uploader'

export default {
  props: ['contact', 'editContact', 'visable', 'editProject'],
  data () {
    return {
      ifSendToLeads: false,
      getContact: {},
      contactList: [],
      items: [],
      search: null,
      customerSelect: null,
      loading: false,
      loadingTasks: false,
      projectType: 'new',
      validating: false,
      completedProject: false,
      valid: true,
      errors: false,
      startmodal: false,
      completedmodal: false,
      showUploader: false,
      builderDropDownList: [],
      builderContactsDropDownList: [],
      pickerStartDate: null,
      pickerCompletedDate: null,
      docTimestamp: null,
      uploadedFileList: [],
      addressSameAsContact: true,
      project: {id: null, status: 'Pre-Construction', name: null, contract_amount: null, start_date: new Date(), completed_date: null, building_dept: null, property_survey: null, other_designs: null, financing: null, budget_min: 0, budget_max: 0, address: null, city: null, state: null, zip: null, gate_code: null, hoa: null, description: null, notes: null, projectNotes: null, builder: null, builder_contact: null},
      projectBeforeChanges: null,
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 50) || 'Name must be less than 50 characters'
      ],
      validationRequired: [
        v => !!v || 'Field is required'
      ],
      // rules: {
      //   fileName: v => {
      //     return [A-Za-z0-9].test(v)
      //   }
      // }
      fileNameRules: [
        v => {
          return /^[A-Za-z0-9 _-]*$/.test(v) || 'Use only letters, numbers, spaces, dashes, and underscores'
        }
      ],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 20,
        headers: { 'My-Awesome-Header': 'header value' }
      }
    }
  },
  mounted () {
    this.setId()
    // Get Contact List
    if (this.contact) {
      if (this.contact.secondaryContact_first_name) {
        this.customerSelect = this.contact.first_name + ' ' + this.contact.last_name + ' and ' + this.contact.secondaryContact_first_name + ' ' + this.contact.secondaryContact_last_name
        this.getContact = this.contact
      } else {
        this.customerSelect = this.contact.first_name + ' ' + this.contact.last_name
        this.getContact = this.contact
      }
    } else {
      this.contactList = this.$store.getters.getContactSearchList.map(a => a.name)
    }
    // Get Builder List
    this.BuildersList()
    // Set addressSameAsContact to false if Contact has no address
    if (!this.getContact.address) {
      this.addressSameAsContact = false
    }
    // Edit Contact List From Props
    if (this.editProject) {
      const objKeys = Object.keys(this.project)
      objKeys.forEach(k => {
        if (this.editProject[k] !== 'undefined') {
          this.project[k] = this.editProject[k]
        }
      })
      // Add the current Builder contact to the dropdown list or it will not show up for edits
      if (this.editProject.builder_contact) {
        this.builderContactsDropDownList.push(this.editProject.builder_contact)
      }
      this.projectBeforeChanges = Object.assign({}, this.project)
    }
  },
  watch: {
    search (val) {
      val && val !== this.select && this.querySelections(val)
    },
    getContact () {
      this.addProjectName()
    }
  },
  computed: {
    registerDialog: {
      get () {
        return this.visable
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    sendProjectToLeads () {
      this.$store.dispatch('sendProjectToLeads', {project: this.editProject, contact: this.editContact})
      this.ifSendToLeads = false
      this.$router.push('/leads')
    },
    addProjectName () {
      if (this.getContact.city) {
        this.project.name = this.getContact.last_name + ' - ' + this.getContact.city
      } else {
        this.project.name = this.getContact.last_name + ' Project'
      }
    },
    createContact () {
      this.$emit('createContact')
    },
    getUploadFiles (files) {
      this.uploadedFileList = []
      files.forEach(value => {
        let selectedFileName = value.ref.name.replace(/\.[^/.]+$/, '')
        let selectedFileExtension = value.ref.name.split('.').pop()
        this.uploadedFileList.push({id: this.docTimestamp, name: selectedFileName, type: value.metadata.contentType, extension: selectedFileExtension, path: value.ref.fullPath, timestamp: new Date(), created_by: this.user.id, active: true})
      })
    },
    setId () {
      let milliseconds = String((new Date()).getTime())
      let timestamp = milliseconds + '-' + Math.floor(Math.random() * 1000)
      this.docTimestamp = timestamp
      this.project.id = timestamp
    },
    BuildersList () {
      let obj = this.$store.getters.builderList
      obj.forEach(item => {
        this.builderDropDownList.push(item.company_name)
      })
      this.builderDropDownList = this.builderDropDownList.sort()
    },
    getBuilderContacts (companyName) {
      const builders = this.$store.getters.builderList
      const builder = builders.filter(filter => filter.company_name === companyName)
      builder[0].builder_contacts.forEach(item => {
        this.builderContactsDropDownList.push(item.first_name + ' ' + item.last_name)
      })
    },
    onUpload () {
      // Create a Storage Ref
      if (!this.docTimestamp) {
        this.setId()
      }
      if (this.$refs.form.validate()) {
        let newFile = new File([this.selectedFile], this.selectedFileName + '.' + this.selectedFileExtension, {type: this.selectedFile.type})
        const putFile = storage.ref('projects/' + this.docTimestamp + '/' + newFile.name).put(newFile)

        putFile.on('state_changed', snapshot => {
          this.progressBar = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        })
        putFile.then(response => {
          this.selectedFile = null
          this.selectedFileName = null
          this.selectedFileExtension = null
          this.selectedFileNotes = null
          this.initiateChooseFile = false
        })
        .catch(error => console.log(error))
      }
    },
    createProject () {
      // Is Project Complete?
      if (this.completedProject === true) {
        this.project.status = 'Completed'
      }
      // Set Contact if Exists
      if (this.contact) {
        this.getContact = this.contact
      }
      // Check Validation
      this.validating = true
      // If Creation of New Project
      if (!this.editProject) {
        if (this.$refs.form.validate() && this.customerSelect) {
          if (!this.project.id) {
            this.project.id = this.docTimestamp
          }
          if (!this.getContact || !this.getContact.id) {
            // this.getContactDetails()
          }
          if (this.getContact && this.getContact.id) {
            this.contactAddressPass()
            const projectData = {...this.project, files: this.uploadedFileList, contact_id: this.getContact.id}
            this.$store.dispatch('createProject', projectData)
            this.closeContactAndProject()
          }
        } else {
          this.errors = true
        }
      }
      if (this.editProject) {
        // Find Changes
        const objKeys = Object.keys(this.projectBeforeChanges)
        let differences = {}
        objKeys.forEach(k => {
          if (this.projectBeforeChanges[k] !== this.project[k]) {
            differences = {...differences, [k]: this.project[k]}
          }
        })
        let changesFrom = {}
        objKeys.forEach(k => {
          if (this.projectBeforeChanges[k] !== this.project[k]) {
            changesFrom = {...differences, [k]: this.projectBeforeChanges[k]}
          }
        })
        const payload = {changes: differences, changesFrom: changesFrom, id: this.project.id, name: this.project.name}
        this.$store.dispatch('editProject', payload)
        this.$emit('closeDialog')
      }
    },
    createProjectAndTasks () {
      this.createProject()
      const payload = {projectId: this.docTimestamp, projectName: this.project.name, taskTemplate: 'Pre-Construction', startDate: new Date()}
      this.$store.dispatch('getTaskList', payload)
    },
    getContactDetails () {
      let contactDetails = this.$store.getters.getContactSearchList.filter(f => { return f.name === this.customerSelect })
      contactDetails = Object.assign({}, ...contactDetails)
      db.collection('contacts').doc(contactDetails.id).get().then(query => {
        this.getContact = {...query.data(), id: query.id}
      })
    },
    contactAddressPass () {
      if (this.addressSameAsContact) {
        this.project.address = this.getContact.address
        this.project.city = this.getContact.city
        this.project.state = this.getContact.state
        this.project.zip = this.getContact.zip
      }
      if (!this.getContact.address) {
        this.getContact.address = null
      }
      if (!this.getContact.city) {
        this.getContact.city = null
      }
      if (!this.getContact.state) {
        this.getContact.state = null
      }
      if (!this.getContact.zip) {
        this.getContact.zip = null
      }
    },
    setStartDate () {
      this.project.start_date = new Date(new Date(this.pickerStartDate).getTime() + 57600000)
    },
    setCompletedDate () {
      this.project.completed_date = new Date(new Date(this.pickerCompletedDate).getTime() + 57600000)
    },
    closeContactAndProject () {
      this.$emit('closeDialog')
    },
    querySelections (v) {
      this.loading = true
      // Simulated ajax query
      setTimeout(() => {
        this.items = this.contactList.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 500)
    }
  },
  components: {
    Uploader
  }
}
</script>

<style scoped>
.buttons {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/leads/CustomerLead.vue